export default __webpack_public_path__ + "static/media/HardCut-Active-01.c22bfa08.jpg";